var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIBackArrowBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H4",
    stroke: "#10141A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20L4 12L12 4",
    stroke: "#10141A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBackArrowBtn);
export default __webpack_public_path__ + "static/media/i_back_arrow_btn.3e27c2a68f71818c7c5c4e0131b2cd6b.svg";
export { ForwardRef as ReactComponent };